import React from 'react';
import PropTypes from 'prop-types';
//Material components
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

/**
 * Gera um dialog para confirmação de uma opção
 */
class ConfirmDialog extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleCancelarClick = this.handleCancelarClick.bind(this);
        this.handleConfirmarClick = this.handleConfirmarClick.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
    }

    /**
     * Trata o click no botão cancelar
     */
    handleCancelarClick() {
        if (this.props.onClose)
            this.props.onClose(false);
    }

    /**
     * Trata o click no botão confirmar
     */
    handleConfirmarClick() {
        if (this.props.onClose)
            this.props.onClose(true);
    }

    /**
     * Trata o dialog sendo fechado
     */
    handleDialogClose() {
        if (this.props.onClose)
            this.props.onClose(false);
    }

    render() {
        const {
            open,
            titulo
        } = this.props;

        return (
            <Dialog onClose={this.handleDialogClose} aria-labelledby="simple-dialog-title" open={open}>
                <DialogTitle id="simple-dialog-title">{titulo}</DialogTitle>
                <DialogActions>
                    <Button onClick={this.handleCancelarClick} id="dialog-cancelar" color="default" autoFocus>Cancelar</Button>
                    <Button onClick={this.handleConfirmarClick} id="dialog-confirmar" color="primary" >Ok</Button>
                </DialogActions>
    
            </Dialog>
        );
    }
}

ConfirmDialog.propTypes = {
    /** A mensagem que será exibida no dialog */
    titulo: PropTypes.string.isRequired,
    /** Indica se o dialog estará visível ou não */
    open: PropTypes.bool,
    /** evento disparado quando o dialog for fechado */
    onClose: PropTypes.func
};

ConfirmDialog.defaultProps = {
    open: false
};

export default ConfirmDialog;